import { OptionType, PlanType, ProductTypeId, SimType } from '@app-types/product';
import { ProductTrackingType } from '@app-types/tracking';

export function formatTagText(text?: string) {
    if (!text) return '';
    return text
        .split(' ')
        .join('_')
        .split('&nbsp;')
        .join('_')
        .split('é')
        .join('e')
        .split('è')
        .join('e')
        .split('ê')
        .join('e')
        .split('à')
        .join('a');
}

export type GenericTrackableProductType = OptionType | PlanType | SimType;

export function mapOptionsForTracking(genericProducts: GenericTrackableProductType[]): ProductTrackingType[] {
    return genericProducts.map(mapProductOrOption);
}

export function mapProductOrOption(genericProduct: GenericTrackableProductType): ProductTrackingType {
    const isPlan = 'typeId' in genericProduct && genericProduct.typeId !== ProductTypeId.SIM;
    const transformedProduct = {
        gamme: '',
        gencode: genericProduct.gencode,
        id: genericProduct.gencode,
        ligneProduitNiv1: '',
        ligneProduitNiv2: '',
        price: 'prices' in genericProduct ? (genericProduct.prices?.final ?? 0) : (genericProduct.price ?? 0),
        sku: genericProduct.gencode,
        technology: '',
        type_id: '',
        name: '',
    };
    if ('name' in genericProduct) {
        transformedProduct.name = genericProduct.name;
    }
    if (isPlan) {
        transformedProduct.gamme = 'B&You';
        transformedProduct.type_id = genericProduct.typeId;
        transformedProduct.technology = (genericProduct as PlanType).technology || '';
    }
    return transformedProduct;
}
